import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import GenuineITSystemsbanner from '../../../assets/casestudy/gnanodayabanner.webp';
import Gnanodaya2ndimg from '../../../assets/casestudy/gnanodaya2ndimg.webp';
import Gnanodaya1stimg from '../../../assets/casestudy/gnanodaya1stimg.webp';
import Gnanodaya3rdimg from '../../../assets/casestudy/gnanodaya3rdimg.png';
import Mongodbicon from '../../../assets/img/mongodbicon.svg';
import Nodeicon from '../../../assets/img/nodeicon.svg';
import Reacticon from '../../../assets/img/reacticon.svg';
import Expressicon from '../../../assets/img/expressicon.svg';
import hostec1stimg from '../../../assets/casestudy/hostec1stimg.webp';
import KumarPhotography from '../../../assets/casestudy/KumarPhotoGraphy.webp';
const Gnanodhaya = () => {
  const caseStudiesB = [
  {
    image: hostec1stimg,
    title: 'Hostec',
    category: 'Website Design',
     pagelink:'/hostec',
    link: 'https://hostec.com',
  },
   {
    image: KumarPhotography,
    title: 'Kumar Photography',
    category: 'Website Design',
     pagelink:'/kumarphotography',
    link: 'https://kumarsphoto.com/',
  },
];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];

  return (
    <CaseStudys
    caseStudies={caseStudiesB} 
  
      title="Gnanodhaya VLSI Technologies"
   
      subtitle="Crafting a Visual Platform for a Visual Brand"
      header='Building a platform to simplify VLSI learning for engineering students.'
      websiteUrl='https://gnanodayavlsi.com/'
      industry="Education and Technology"
      services={servicesB}
      description={
        <>
          <span>Gnanodaya VLSI</span>Gnanodaya VLSI is a leading provider of specialized training and educational courses in VLSI (Very-Large-Scale Integration) design and semiconductor technology. With a focus on empowering individuals and professionals with the skills needed to excel in the VLSI and electronics industry, Gnanodaya VLSI offers tailored courses designed to provide both theoretical knowledge and practical experience. Their programs aim to bridge the gap between education and industry, helping students and professionals stay ahead in the rapidly evolving field of semiconductor technology.
        </>
      }
      objective={{
        heading: 'Building a Clear Website to Showcase Gnanodaya VLSI’s Expertise & Courses',
        content: (
          <>
            <p className={styles.projectText}>
             The objective behind designing the Gnanodaya VLSI website was to create a professional, informative platform that effectively showcases the company’s educational offerings in VLSI design and semiconductor technology. The website aims to provide clear and accessible information about their specialized courses, instructors, and successful alumni, helping prospective students make informed decisions about their education. The goal was to enhance Gnanodaya VLSI’s online presence, making it easier for individuals and professionals to explore, enroll, and engage with their training programs, ultimately positioning the company as a leading provider of VLSI education.
            </p>

           
          </>
        ),
      }}
      process={{
        heading: "The Process Behind Designing the Website for Gnanodhaya VLSI",
        content: (
          <>
            <p className={styles.projectText}>
           Once the wireframes and design were approved, we moved into the development phase, ensuring the website was responsive and optimized for all devices. The site was designed with an intuitive layout, highlighting key features such as course details, faculty profiles, and success stories. SEO best practices were incorporated to enhance the site’s visibility and attract organic traffic from search engines. The final product ensures that visitors can easily navigate through the educational offerings and access relevant information, positioning Gnanodaya VLSI as a go-to provider for VLSI education.
            </p>

         

            <p className={styles.projectText}>
           The design process for the Gnanodaya VLSI website began with understanding the core goals of the company—providing specialized educational courses in VLSI design and semiconductor technology. We conducted research into the target audience, including students, professionals, and educational institutions, to create a platform that would effectively communicate Gnanodaya’s expertise and the value of their courses. The website design focused on clarity, showcasing the range of programs offered, and ensuring a smooth user experience for prospective students looking for detailed information on course structures, enrollment, and outcomes
            </p>
          </>
        ),
      }}
      impact={{
        heading: 'Improving Visibility and Trust for Gnanodaya VLSI',
        content: (
          <>
            <p className={styles.projectText}>
           The impact of the Gnanodaya VLSI website has been significant in increasing the company’s visibility and attracting prospective students to their specialized educational programs. The user-friendly design and easy navigation have made it simpler for visitors to explore course offerings, learn about faculty expertise, and understand the benefits of the training programs. This has resulted in a higher volume of inquiries and course enrollments.
            </p>
            <p className={styles.projectText}>
          Additionally, the responsive design ensures a seamless experience across devices, expanding the reach of Gnanodaya VLSI’s educational services. With improved search engine visibility through SEO optimization, the website has driven more organic traffic, helping the company connect with a broader audience of students and professionals looking to advance their careers in VLSI and semiconductor technology. Overall, the website has strengthened Gnanodaya VLSI's position as a trusted leader in VLSI education and contributed to the growth of their student base.
            </p>
           
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
        In conclusion, the Gnanodaya VLSI website successfully meets its objective of providing a user-friendly and informative platform for prospective students interested in VLSI design and semiconductor technology education. The clean and intuitive design has made it easier for users to explore course offerings and engage with the company’s services. By improving the website’s visibility and accessibility, Gnanodaya VLSI has strengthened its reputation as a leading provider of specialized VLSI education. The website has not only attracted more students but also positioned the company for continued growth and success in the education sector.
            </p>
           
          </>
        ),
      }}
      heroImage={GenuineITSystemsbanner} // Add the hero image
      projectImage={Gnanodaya1stimg}
       projectImage2={Gnanodaya2ndimg}
           projectImage3={Gnanodaya3rdimg}
       // Add the project image
      technologies={[
           { name: 'MongoDB', icon: Mongodbicon },
        { name: 'Node.js', icon: Nodeicon },
        { name: 'React', icon: Reacticon },
        { name: 'Express.js', icon: Expressicon },
      ]} // Add the technologies used
      timescale="20 Weeks" // Add the timescale
      launchDate="February 2025" // Add the launch date
    />
  );
};

export default Gnanodhaya;